export default "__VITE_ASSET__b226dc60__"